<yc-modal
  [modalHeader]="'login:hdrAgreeToTerms' | ycI18n: 'Agree to Terms'"
  [primaryButtonText]="'common:btnAgreeToTerms' | ycI18n: 'Agree to terms'"
  [cancelButtonText]="'common:btnSignOut' | ycI18n: 'Sign out'"
  (onCancel)="onCancel()"
  (onPrimaryClick)="onSubmit()">
  <p>
    <yc-i18n
      key="login:textUseOfGrantsConnectIsSubjectToTerms"
      defaultValue="Use of the GrantsConnect platform is subject to the terms below.  Please take time to review and agree before proceeding.">
    </yc-i18n>
  </p>
  <div class="d-flex mt-4">
    <div class="col">
      <yc-button [link]="true"
        (onClick)="openTermsOfService()">
        <yc-fa icon="external-link" class="me-2"></yc-fa>
        <yc-i18n
          key="common:textTermsOfService"
          defaultValue="Terms of Service">
        </yc-i18n>
      </yc-button>
    </div>
    <div class="col">
      <yc-button [link]="true"
        (onClick)="openPrivacyPolicy()">
        <yc-fa icon="external-link" class="me-2"></yc-fa>
        <yc-i18n
          key="common:textPrivacyPolicy"
          defaultValue="Privacy Policy">
        </yc-i18n>
      </yc-button>
    </div>
  </div>
</yc-modal>